import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import ComisionManual from "../../../../types/ComisionManual";
import { formatIsoDate, formatMoney } from "../../../helpers/formatters";

interface Props {
  data: ComisionManual[];
  loading: boolean;
  onExport: () => void;
}

export const MemoTable = React.memo<Props>(({ data, loading, onExport }) => {
  const [columns, setColumns] = useState(columnsFormatter());

  useEffect(() => {
    setColumns(columnsFormatter());
  }, []);

  const totalComisiones = data
    ? data.reduce((sum, c) => sum + (c.montoComision || 0), 0)
    : 0;

  return (
    <>
      <div className="row">
        {!!data && !!data.length && (
          <>
            <div className="col-6 p-0" style={{ lineHeight: "40px" }}>
              <span>
                Comisiones mostradas: {data.length} - (Monto total:{" "}
                {formatMoney(totalComisiones)})
              </span>
            </div>
            <div
              className="col-6 p-0 text-right"
              style={{ lineHeight: "40px" }}
            >
              <Button
                color="primary"
                onClick={onExport}
                disabled={loading}
                className="mr-2"
              >
                <FontAwesomeIcon icon={faFileExport} />
                {!loading ? " Exportar CSV" : " Espere..."}
              </Button>
            </div>
          </>
        )}
      </div>

      <div className="row mt-2">
        <div style={{ width: "100%" }}>
          <ReactTable
            data={data || []}
            columns={columns}
            loading={loading}
            defaultPageSize={(data && data.length > 5 && data.length) || 5}
            className="-striped -highlight"
            showPagination={false}
            showPageSizeOptions={false}
            getTrProps={() => ({ style: { height: "30px" } })}
            sortable={false}
            noDataText="No se encontraron comisiones para el periodo seleccionado"
          />
        </div>
      </div>
    </>
  );
});

function columnsFormatter() {
  return [
    {
      Header: "No. Emp.",
      id: "numeroEmpleado",
      width: 64,
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => row.numeroEmpleado
    },
    {
      Header: "Empleado",
      id: "empleado",
      width: 256,
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => row.empleado
    },
    {
      Header: "Club",
      id: "club",
      width: 96,
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => row.club
    },
    {
      Header: "C. Nómina",
      id: "conceptoNomina",
      width: 80,
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => row.conceptoNomina
    },
    {
      Header: "Descripción",
      id: "descripcion",
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => row.descripcion
    },
    {
      Header: "Monto",
      id: "montoComision",
      width: 64,
      headerClassName: "text-right",
      className: "text-right",
      accessor: (row: ComisionManual) => formatMoney(row.montoComision)
    },
    {
      Header: "Fecha Pago",
      id: "fechaPago",
      width: 96,
      headerClassName: "text-left",
      accessor: (row: ComisionManual) => formatIsoDate(row.fechaPago)
    }
  ];
}
